import { OrganizationUrlProps, RolesUrlProps } from '@logic'
import { newDeleteFunction, newPostFunction, newPutFunction } from '@src/service/lib'
import { NewMemberRoleRequest, NewRoleRequest, UpdateRoleRequest } from './request'
import { memberRoleUrl, rolesUrl, roleUrl } from './urls'

export const createNewRole = newPostFunction<OrganizationUrlProps, NewRoleRequest, {}>(rolesUrl)
export const editRole = newPutFunction<RolesUrlProps, UpdateRoleRequest, {}>(roleUrl)
export const deleteRole = newDeleteFunction<RolesUrlProps, {}>(roleUrl)
export const editMemberRole = newPutFunction<RolesUrlProps, NewMemberRoleRequest, {}>(memberRoleUrl)
